import {useState} from 'react';
import {motion} from 'framer-motion';
import {submitContactForm} from '../services/wordpressApi';

function Contact({content}) {
  const [formValues,setFormValues]=useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting,setIsSubmitting]=useState(false);
  const [status,setStatus]=useState({type: '',message: ''});

  const handleChange=(event)=> {
    const {name,value}=event.target;
    setFormValues((current)=> ({...current,[name]: value}));
    setStatus({type: '',message: ''});
  };

  const handleSubmit=async (event)=> {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      event.currentTarget.reportValidity();
      return;
    }

    setIsSubmitting(true);
    setStatus({type: '',message: ''});

    try {
      await submitContactForm(formValues);
      setFormValues({name: '',email: '',message: ''});
      setStatus({
        type: 'success',
        message: 'Thanks — your message has been sent.'
      });
    } catch {
      setStatus({
        type: 'error',
        message: 'Something went wrong. Please try again.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact" aria-labelledby="contact-heading">
      <motion.img
        className="contact-image"
        src={content.contact_image.url}
        alt={content.contact_image.alt}
        loading="lazy"
        initial={{opacity: 0,scale: 0.9}}
        whileInView={{opacity: 1,scale: 1}}
        viewport={{once: true}}
        transition={{duration: 0.55}}
      />
      <motion.div
        className="contact-copy"
        initial={{opacity: 0,y: 20}}
        whileInView={{opacity: 1,y: 0}}
        viewport={{once: true}}
        transition={{duration: 0.55}}
      >
        <h2 id="contact-heading">{content.contact_heading}</h2>
        <p>{content.contact_text}</p>
        <a href={`mailto:${content.contact_email}`}>
          {content.contact_email}
        </a>

        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <label htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            value={formValues.name}
            onChange={handleChange}
            required
          />

          <label htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            value={formValues.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            name="message"
            value={formValues.message}
            onChange={handleChange}
            required
            rows="4"
          />

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Sending…' : 'Send Message'}
          </button>

          {status.message && (
            <p
              className={`contact-form-status contact-form-status-${status.type}`}
              role="status"
              aria-live="polite"
            >
              {status.message}
            </p>
          )}
        </form>
      </motion.div>
    </section>
  );
}

export default Contact;